import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../../../utils/reduxHelper";

export const sourcingMyOrdersReduxAPI = createApi({
  reducerPath: "sourcingMyOrdersReduxAPI",
  baseQuery: baseQueryWithArgs,

  tagTypes: ["getMyOrders", "getMyOrdersStatusOptions"],

  endpoints: (builder) => ({
    //GET Queries
    getMyOrders: builder.query({
      query: ({
        startDate,
        endDate,
        statuses,
        contentPending,
        toBeReturned,
        isSourcing,
        isBrandSourcing,
        page,
      }) => {
        const statusesString = JSON.stringify(statuses);
        const contentPending_string = contentPending ? "true" : "false";
        const toBeReturned_string = toBeReturned ? "true" : "false";
        const isSourcing_string = isSourcing ? "true" : "false";
        const isBrandSourcing_string = isBrandSourcing ? "true" : "false";
        return getQueryStringWithCreator(
          `s/getMyOrders?startDate=${startDate}&endDate=${endDate}&statuses=${statusesString}&contentPending=${contentPending_string}&toBeReturned=${toBeReturned_string}&page=${page}&isSourcing=${isSourcing_string}&isBrandSourcing=${isBrandSourcing_string}`
        );
      },
      providesTags: ["getMyOrders"],
    }),
    getMyOrderStatusOptions: builder.query({
      query: ({ startDate, endDate }) =>
        getQueryStringWithCreator(
          `s/getMyOrdersStatusOptions?startDate=${startDate}&endDate=${endDate}`
        ),
      invalidatesTags: ["getMyOrdersStatusOptions"],
    }),
    getSearchMyOrders: builder.query({
      query: ({ searchText }) =>
        getQueryStringWithCreator(`s/searchLineItems?search=${searchText}`),
      providesTags: ["getSearchMyOrders"],
    }),
    postPlaceLineItemReturnRequest: builder.mutation({
      query: (body) => ({
        url: "s/placeLineItemReturnRequest",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["getMyOrders"],
    }),
    updateSupportOnBoarding: builder.mutation({
      query: (body) => ({
        url: "s/updateCentralNumberOnBoardingCounter",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    postFeedback: builder.mutation({
      query: (body) => ({
        url: "s/addFeedback",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetMyOrdersQuery,
  useLazyGetMyOrderStatusOptionsQuery,
  useGetSearchMyOrdersQuery,
  usePostPlaceLineItemReturnRequestMutation,
  useUpdateSupportOnBoardingMutation,
  usePostFeedbackMutation,
} = sourcingMyOrdersReduxAPI;
